import { BasicDialog } from 'library';
import React from 'react';
import { Provider } from 'models';
import PublicMessaging from './PublicMessaging';
import { track } from 'shared';

export default function PublicMessagingModal({
    provider,
    open,
    close,
    location,
}: {
    provider: Provider;
    open: boolean;
    close: () => void;
    location: string;
}) {
    return (
        <BasicDialog
            isOpen={open}
            onClose={() => {
                track(`Public Message Provider Modal Closed`, { location });
                close();
            }}
            closeButton={true}
        >
            <PublicMessaging provider={provider} />
        </BasicDialog>
    );
}
